<template>
  <v-card elevation="4" :class="`d-flex ${column? 'flex-column': 'justify-start align-center status--layout'} pa-2 status status--border-${colour} ${ isFilterActive ? 'status--bg' : '' }`" @click="filter">

    <v-card-title class="pa-0 text-center text-no-wrap">{{ statusData.status }}</v-card-title>

    <v-card-text :class="`d-flex ${column? 'flex-column': 'justify-space-between align-center status--layout'} pa-0`">

      <div :class="`text-h6 text-center ${colour}--text font-weight-regular`">{{ statusData.count }}</div>
      <div class="text-body-1 text-center black--text">{{ balanceSum | formatCurrency }}</div>

    </v-card-text>

  </v-card>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  export default {
    props: {
      statusData: {
        type: Object,
        default: ()=> ({})
      },

      colour: {
        type: String,
        default: ''
      },

      column: {
        type: Boolean,
        default: true
      }
    },

    computed: {
      ...mapGetters('creditControlDashboard', ['getCreditControlAccountsFilters', 'getCreditControlAccountsConfig']),

      statusMap() {
        return (status) => {
          const map = {
            'exclude': 'Excluded',
            'comms': 'No Comms',
          };

          if(map[status]) return map[status];
          return status;
        };
      },

      isFilterActive() {
        const allStatuses = [...this.getCreditControlAccountsConfig.status, ...this.getCreditControlAccountsConfig.exclusion_kind];
        const mappedStatuses = allStatuses.map(status => this.statusMap(status));
        return mappedStatuses.includes(this.statusData.status);
      },

      balanceSum() {
        if (this.statusData.sum) {
          return this.statusData.sum.balance__sum > 0 ? this.statusData.sum.balance__sum : 0;
        }
        return '';
      }
    },

    methods: {
      ...mapActions('creditControlDashboard', ['updateCreditControlAccountsStatuses']),

      filter() {
        const statusMetric = this.getCreditControlAccountsFilters['statusMetrics'].find(metric => metric.text === this.statusData.status);
        const filterBy = {
          [statusMetric.category]: statusMetric.value
        };

        this.updateCreditControlAccountsStatuses(filterBy);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .v-card {
  overflow: hidden;
  }
  .status--layout {
    column-gap: 10px;
  }

  .status--border-primary {
    border-left: 5px solid#42CCCC;
  }

  .status--border-success {
    border-left: 5px solid#4caf50;
  }

  .status--border-warning {
    border-left: 5px solid#fb8c00;
  }

  .status--border-error {
    border-left: 5px solid#f1667c;
  }
  .status--bg {
    background-color: lightgray;
  }
</style>